/**
 * @flow
 * @relayHash b408184be663421a8880464473431ba6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserSavedFilterType = "BACKORDER" | "CUSTOMER" | "INVOICE" | "ITEM" | "JOB" | "LOT" | "ORDER" | "RETURN_ORDER" | "SHIPMENT";
export type UpdateUserSavedFilterInput = {|
  id: string,
  name?: ?string,
  filter?: ?string,
|};
export type UpdateUserSavedFilterMutationVariables = {|
  input?: ?UpdateUserSavedFilterInput
|};
export type UpdateUserSavedFilterMutationResponse = {|
  +updateUserSavedFilter: {|
    +userSavedFilterEdge: {|
      +node: {|
        +id: string,
        +name: string,
        +type: UserSavedFilterType,
        +filter: string,
      |}
    |}
  |}
|};
export type UpdateUserSavedFilterMutation = {|
  variables: UpdateUserSavedFilterMutationVariables,
  response: UpdateUserSavedFilterMutationResponse,
|};
*/


/*
mutation UpdateUserSavedFilterMutation(
  $input: UpdateUserSavedFilterInput
) {
  updateUserSavedFilter(input: $input) {
    userSavedFilterEdge {
      node {
        id
        name
        type
        filter
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserSavedFilterInput",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUserSavedFilter",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserSavedFilterPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userSavedFilterEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "UserSavedFilterEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "UserSavedFilter",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "filter",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateUserSavedFilterMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateUserSavedFilterMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateUserSavedFilterMutation",
    "id": null,
    "text": "mutation UpdateUserSavedFilterMutation(\n  $input: UpdateUserSavedFilterInput\n) {\n  updateUserSavedFilter(input: $input) {\n    userSavedFilterEdge {\n      node {\n        id\n        name\n        type\n        filter\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c7be58c788b413b880aa1ad62791a99a';
module.exports = node;
